(() => {
  'use strict';

  function initDeadPixel(root) {
    if (root.dataset.dgLabDeadPixelInitialized === 'true') return;
    root.dataset.dgLabDeadPixelInitialized = 'true';

    const controller = new AbortController();
    root.dgLabDeadPixelCleanup = () => controller.abort();

    const stage = root.querySelector('#dg-lab-stage');
    const color = root.querySelector('#dg-lab-color');
    const state = root.querySelector('#dg-lab-state');
    const status = root.querySelector('.status');
    const next = root.querySelector('#dg-lab-next');
    const prev = root.querySelector('#dg-lab-prev');
    const full = root.querySelector('#dg-lab-full');

    if (!stage || !color || !next || !prev || !full) return;

    const colors = ['#000', '#fff', '#f00', '#0f0', '#00f', '#777'];
    const names = ['Negro', 'Blanco', 'Rojo', 'Verde', 'Azul', 'Gris'];

    let index = 0;

    function setStatus(text) {
      if (status) status.textContent = text;
    }

    function setPattern() {
      stage.style.background = colors[index];
      color.textContent = names[index];
    }

    function showNextPattern() {
      index = (index + 1) % colors.length;
      setPattern();
    }

    function showPreviousPattern() {
      index = (index + colors.length - 1) % colors.length;
      setPattern();
    }

    async function toggleFullscreen(target) {
      if (!target || !document.fullscreenEnabled) {
        setStatus('No disponible');
        return;
      }

      try {
        if (document.fullscreenElement) {
          await document.exitFullscreen();
        } else {
          await target.requestFullscreen();
        }
      } catch (error) {
        setStatus('No disponible');
      }
    }

    next.addEventListener(
      'click',
      showNextPattern,
      { signal: controller.signal }
    );

    prev.addEventListener(
      'click',
      showPreviousPattern,
      { signal: controller.signal }
    );

    full.addEventListener(
      'click',
      () => toggleFullscreen(stage),
      { signal: controller.signal }
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (document.fullscreenElement !== stage) return;

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showNextPattern();
          return;
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showPreviousPattern();
        }
      },
      { signal: controller.signal }
    );

    document.addEventListener(
      'fullscreenchange',
      () => {
        if (!state) return;

        state.textContent =
          document.fullscreenElement === stage
            ? 'Pantalla completa activa - Flechas ← → para cambiar · Esc para salir'
            : 'Listo';
      },
      { signal: controller.signal }
    );

    setPattern();
  }

  function initAll() {
    document
      .querySelectorAll('.dg-lab[data-dg-lab-tool="dead-pixel"]')
      .forEach(initDeadPixel);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('shopify:section:unload', (event) => {
    event.target
      .querySelectorAll('.dg-lab[data-dg-lab-tool="dead-pixel"]')
      .forEach((root) => {
        root.dgLabDeadPixelCleanup?.();
        delete root.dataset.dgLabDeadPixelInitialized;
      });
  });

  initAll();
})();